document.addEventListener('DOMContentLoaded', function () {

    const ics = require('ics');
    var FileSaver = require('file-saver');

    const eventsTable = () => {

        const table = document.querySelector('.is-style-jdw-calendar-style');

        if (table) {
            const tableRows = table.querySelectorAll('tr');
            tableRows.forEach((row) => {

                // Set default values
                let eventDate;
                let eventDay;
                let eventMonth;
                let eventYear;
                let eventStartTime;
                let eventEndTime;
                let eventTitle;
                let eventDescription;

                const tableCells = row.querySelectorAll('td');
                tableCells.forEach((cell) => {

                    // If first cell
                    if (cell && cell.cellIndex === 0) {
                        eventDate = cell.innerText;
                        eventDay = new Date(eventDate).toLocaleString("en-gb", { day: 'numeric' });
                        eventMonth = new Date(eventDate).toLocaleString("en-gb", { month: 'numeric' });
                        eventYear = new Date(eventDate).toLocaleString("en-gb", { year: 'numeric' });

                        eventStartTime = cell.getAttribute('data-start-time');
                        eventEndTime = cell.getAttribute('data-end-time');
                        

                    }

                    // If middle cell
                    if (cell && cell.cellIndex === 1) {
                        eventTitle = cell.innerText;
                        eventDescription = cell.getAttribute('data-desc');
                    }

                    // If last cell
                    if (cell && cell.cellIndex === 2) {

                        const event = {
                            start: [Number(eventYear), Number(eventMonth), Number(eventDay), Number(eventStartTime.substring(0, 2)), Number(eventStartTime.substring(3, 5))],
                            end: [Number(eventYear), Number(eventMonth), Number(eventDay), Number(eventEndTime.substring(0, 2)), Number(eventEndTime.substring(3, 5))],
                            title: eventTitle,
                            description: eventDescription.toString(),
                        }

                        ics.createEvent(event, (error, value) => {
                            if (error) {
                                console.log(error)
                                return
                            }

                            // Download event file
                            cell.addEventListener('click', (e) => {
                                e.preventDefault();
                                var blob = new Blob([value], {type: "text/calendar;charset=utf-8"});
                                FileSaver.saveAs(blob, `${eventTitle.toLowerCase().replace(/\s+/g, '-')}.ics`);
                                console.log('Downloading event file...');
                            });
                        });
                    }

                });
            });

        }

    }

    eventsTable();

});